import React from 'react';
import propTypes from 'prop-types';
import { StripeBillingSchemeWithAmount, StripeAmount, UCFirst } from 'client/components/Helpers/Strings';
import { StripeBillingTiersList } from 'client/components/Helpers/Stripe';
import { connect } from 'react-redux';
import * as subscriptionActions from 'client/redux/account/subscriptionActions';
import HelpTooltip from 'client/components/Helpers/HelpTooltip';
import * as stripeHelpers from 'client/helpers/stripe';

/**
 * @desc Represents a subscription item in a subscription
 */
class AccountSubscriptionItemRow extends React.Component {

  static propTypes = {
    allPlansByStripeId: propTypes.object.isRequired,
    plan: propTypes.string.isRequired,
    subscriptionId: propTypes.string,
    quantity: propTypes.number,
    deleted: propTypes.bool,
    canDelete: propTypes.bool,
    disabled: propTypes.bool,
  };

  static defaultProps = {
    canDelete: true,
  };

  handleChangeQuantity = add => {
    const { plan, subscriptionId, quantity } = this.props;
    return this.props.accountSubscriptionChangePlanQuantity(subscriptionId, plan, quantity + add);
  };

  handleToggleDeleted = () => {
    const { plan, subscriptionId, deleted } = this.props;
    return this.props.accountSubscriptionRemovePlan(subscriptionId, plan, !deleted);
  };

  getPlanObject () {
    const { plan, allPlansByStripeId } = this.props;
    return allPlansByStripeId[plan] || {};
  }

  renderDeleteButton () {
    const { canDelete, deleted, disabled } = this.props;
    if (deleted) {
      return (
        <button className="btn btn-default" type="button" onClick={this.handleToggleDeleted} disabled={disabled} title="Undo removing this plan from the subscription">
          <i className="icon mdi mdi-undo icon-left"></i>
        </button>
      );
    } else {
      return (
        <button className="btn btn-default" type="button" onClick={this.handleToggleDeleted} disabled={disabled || !canDelete} title="Remove this plan from the subscription">
          <i className="icon mdi mdi-delete icon-left"></i>
        </button>
      );
    }
  }

  render () {
    const { quantity } = this.props;
    const planObject = this.getPlanObject();
    return (
      <tr>
        <td>{planObject.name}</td>
        <td><UCFirst str={planObject.type} /></td>
        <td className="number">
          <StripeBillingSchemeWithAmount plan={planObject} />
          {planObject.billingScheme === 'tiered' && planObject.tiers.length > 0 && (
            <>
              {' '}
              <HelpTooltip>
                <div className="xs-m-10">
                  <StripeBillingTiersList
                    tiers={planObject.tiers}
                    currency={planObject.currency}
                    unitLabel={planObject.unitLabel}
                    interval={planObject.interval}
                  />
                </div>
              </HelpTooltip>
            </>
          )}
        </td>
        <td className="number">
          {stripeHelpers.planHasQuantity(planObject) ? (
            <div className="btn-group">
              <button className="btn btn-default" type="button" disabled>{quantity}</button>
              <button
                className="btn btn-default"
                type="button"
                title="Increase amount"
                onClick={ev => this.handleChangeQuantity(1)}
              >
                <i className="icon mdi mdi-long-arrow-up"></i>
              </button>
              <button
                className="btn btn-default"
                type="button"
                title="Decrease amount"
                onClick={ev => this.handleChangeQuantity(-1)}
              >
                <i className="icon mdi mdi-long-arrow-down"></i>
              </button>
            </div>
          ) : (
            <span>-</span>
          )}
        </td>
        <td className="number">
          {isFinite(planObject.amount) && typeof planObject.amount === 'number' ? (
            <StripeAmount
              amount={planObject.amount * (stripeHelpers.planHasQuantity(planObject) ? planObject.quantity : 1)}
              currency={planObject.currency}
            />
          ) : '-'}
        </td>
        <td className="text-right">
          {this.renderDeleteButton()}
        </td>
      </tr>
    );
  }

}

const actions = {
  ...subscriptionActions,
};

export default connect(null, actions)(AccountSubscriptionItemRow);
